import { SettelementLetterDto } from './SettelementLetterDocument';

export class PaymentDetailsDto {
    private settelementLetterDocument: SettelementLetterDto;
    private amount: number;
    private paidAmount: number;
    private tdsAmount: number;
    private utrNumber: string;
    private dateOfPayment: Date;
    private commentBox: string;


    constructor(paymentDetailsDto: any) {
        this.amount = paymentDetailsDto.amount;
        this.paidAmount = paymentDetailsDto.paidAmount;
        this.tdsAmount = paymentDetailsDto.tdsAmount;
        this.utrNumber = paymentDetailsDto.utrNumber;
        this.dateOfPayment = paymentDetailsDto.dateOfPayment;
        this.commentBox = paymentDetailsDto.commentBox;
        if (paymentDetailsDto.settelementLetterDocument) {
            this.settelementLetterDocument = new SettelementLetterDto(paymentDetailsDto.settelementLetterDocument);
        } else {
            this.settelementLetterDocument = new SettelementLetterDto({});
        }

    }

    /**
     * Getter $amount
     * @return {boolean}
     */
	 public set $amount(value: number) {
        this.amount = value;
    }

    /**
     * Setter $amount
     * @param {number} value
     */
     public get $amount(): number {
        return this.amount;
    }

    /**
     * Getter $paidAmount
     * @return {boolean}
     */
	 public set $paidAmount(value: number) {
        this.paidAmount = value;
    }

    /**
     * Setter $paidAmount
     * @param {number} value
     */
     public get $paidAmount(): number {
        return this.paidAmount;
    }

    /**
     * Getter $tdsAmount
     * @return {boolean}
     */
	 public set $tdsAmount(value: number) {
        this.tdsAmount = value;
    }

    /**
     * Setter $tdsAmount
     * @param {number} value
     */
     public get $tdsAmount(): number {
        return this.tdsAmount;
    }

      /**
     * Getter $utrNumber
     * @return {boolean}
     */
	 public set $utrNumber(value: string) {
        this.utrNumber = value;
    }

    /**
     * Setter $utrNumber
     * @param {number} value
     */
     public get $utrNumber(): string {
        return this.utrNumber;
    }

    /**
     * Getter $dateOfPayment
     * @return {boolean}
     */
	 public set $dateOfPayment(value: Date) {
        this.dateOfPayment = value;
    }

    /**
     * Setter $dateOfPayment
     * @param {number} value
     */
     public get $dateOfPayment(): Date {
        return this.dateOfPayment;
    }

        /**
     * Getter $commentBox
     * @return {boolean}
     */
	 public set $commentBox(value: string) {
        this.commentBox = value;
    }

    /**
     * Setter $commentBox
     * @param {number} value
     */
     public get $commentBox(): string {
        return this.commentBox;
    }

    /**
     * Getter $SettelementLetterDto
     * @return {SettelementLetterDto}
     */
     public get $settelementLetterDocument(): SettelementLetterDto {
        return this.settelementLetterDocument;
    }

    /**
     * Setter $SettelementLetterDto
     * @param {SettelementLetterDto} value
     */
    public set $settelementLetterDocument(value: SettelementLetterDto) {
        this.settelementLetterDocument = value;
    }
}
